/* eslint-disable prefer-const */
/* eslint-disable @typescript-eslint/member-ordering */
import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, ReplaySubject } from 'rxjs';
import { environment } from 'src/environments/environment';
import {map} from 'rxjs/operators';
import { User } from '../../models/user.model';

@Injectable({
  providedIn: 'root'
})

export class UserService {

  apiUrl = environment.apiUrl;
  private usersSource = new ReplaySubject<any>(1);
  private paginationSource = new ReplaySubject<any>(1);
  allUsers$ = this.usersSource.asObservable();
  paginationSettings$ = this.paginationSource.asObservable();


  constructor(private http: HttpClient) { }

  addUser(user: User) {
    user.password = `${user.firstName[0].toUpperCase()}${this.capitalizeFirstLetter(user.lastName)}`;
    user.confirmPassword = user.password;
    if(user.role === 'Manager' || user.role === 'Admin' || user.role==="Operater") {
      user.managerId = 0;
    }
    console.log("servisuser")
    console.log(user)
    return this.http.post(this.apiUrl + 'user', user);
  }

  getAllUsers(queryParams = {currentPage: 0, itemsPerPage: 0, usernameQuery: '', firstNameQuery: '', lastNameQuery: '',
   idCardNoQuery: ''}) {
    let params = new HttpParams();
    params = params.append('usernameQuery', queryParams.usernameQuery);
    params = params.append('firstNameQuery', queryParams.firstNameQuery);
    params = params.append('lastNameQuery', queryParams.lastNameQuery);
    params = params.append('idCardNoQuery', queryParams.idCardNoQuery);
    params = params.append('pageNumber', queryParams.currentPage);
    params = params.append('pageSize', queryParams.itemsPerPage);
    return this.http.get(this.apiUrl + 'user', {params, observe: 'response'}).pipe(map((res: any) => {

      if(res) {
        this.paginationSource.next(JSON.parse(res.headers.get('pagination')));
        this.usersSource.next(res.body);
      }
    })).toPromise();
  }

  editUser(user) {
    console.log("User",user)
    return this.http.put(`${this.apiUrl}user/${user.id}`, user);
  }

  deleteUser(id) {
    return this.http.delete(`${this.apiUrl}user/${id}`);
  }

  changePassword(req) {
    return this.http.post(`${this.apiUrl}user/changePassword`, req);
  }

  resetPassword(user: User) {
    const password = `${user.firstName[0].toUpperCase()}${this.capitalizeFirstLetter(user.lastName)}`;
    const confirmPassword = password;
    const req = {username: user.username, password, confirmPassword};
    user.password = password;
    return this.http.post(`${this.apiUrl}user/resetPassword`, req);
  }

  // eslint-disable-next-line id-blacklist
  capitalizeFirstLetter(string: string) {
    // eslint-disable-next-line id-blacklist
    return string.charAt(0).toUpperCase() + string.slice(1);
  }
 getAllUsersSub(queryParams = {currentPage: 0, itemsPerPage: 0}): Observable<User[]> {
    let params = new HttpParams();
    params = params.append('pageNumber', queryParams.currentPage);
    params = params.append('pageSize', queryParams.itemsPerPage);
  return this.http.get<User[]>(this.apiUrl + 'User',{params});
}



}
